module.exports = __webpack_public_path__ + "img/thumbnail_Alpaca_m_melanistic.bf592c40.png";